/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Engine_WordInputs */



/**
* | output |
* | --- |
* | "Word" |
*
* @param {Spellcheck_Engine_WordInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_engine_word = /** @type {((inputs?: Spellcheck_Engine_WordInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Engine_WordInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Word")
	if (locale === "de") return /** @type {LocalizedString} */ ("Word")
	if (locale === "it") return /** @type {LocalizedString} */ ("Word")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Word")
	if (locale === "es") return /** @type {LocalizedString} */ ("Word")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Word")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Word")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Word")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Word")
	return /** @type {LocalizedString} */ ("Word")
});